export default "__VITE_ASSET__$n1CRNBu__"